<template>
    <div class="phone-input-wrapper">
        <div class="phone-input-container">
            <InputSelect 
                :options="countryPrefixes"
                :selected="prefix"
                placeholder="País"
                @selectedOptionChanged="onPrefixChanged"
            />
            <InputField 
                inputType="tel"
                :placeholder="placeholder"
                :label="label"
                :currentValue="phoneNumber"
                @valueChanged="onPhoneNumberChanged"
                :isRequired="isRequired"
            />
        </div>
    </div>
</template>

<script>
import { COUNTRY_PREFIXES } from '@/data/country_prefixes';
import InputField from './InputField.vue';
import InputSelect from './InputSelect.vue';

export default {
    name: 'PhoneInputField',
    components: {
        InputField,
        InputSelect
    },
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'Teléfono'
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        currentValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            prefix: '+34',
            phoneNumber: '',
            countryPrefixes: COUNTRY_PREFIXES
        }
    },
    methods: {
        onPhoneNumberChanged(value) {
            this.phoneNumber = value;
            this.emitPhoneValue();
        },
        onPrefixChanged(newPrefix) {
            this.prefix = newPrefix;
            this.emitPhoneValue();
        },
        emitPhoneValue() {
            const fullPhone = {
                prefijo: this.prefix,
                numero: this.phoneNumber
            };
            this.$emit('valueChanged', fullPhone);
        }
    }
}
</script>

<style scoped>
    .phone-input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .phone-input-container {
        display: flex;
        gap: 32px;
    }

    .phone-input-container > :deep(div) {
        flex: 1;
    }

    .phone-input-container > :deep(div:first-child) {
        flex: 0 0 auto;
        min-width: 120px;
    }

    .phone-input-container > :deep(div:first-child .select-container) {
        width: 100%;
    }

    @media (max-width: 768px) {
        .phone-input-container {
            display: flex;
            gap: 8px;
        }
    }

    @media (min-width: 769px) and (max-width: 992px) {
        .phone-input-container {
            display: flex;
            gap: 8px;
        }
    }

    @media (min-width: 993px) {
        .phone-input-container {
            display: flex;
            gap: 8px;
        }
    }
</style>